import { useState, useMemo, useEffect } from "react";
import Swal from "sweetalert2";
import StudentTemplate from "../../component/StudentTemplate";
import Select from "react-select";
import Api from "../../component/Api";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import CreatableSelect from "react-select/creatable";


const StudentInternship = () => {
  const [selectedCourse, setSelectedCourse] = useState('');
  const [isNotListed, setIsNotListed] = useState(false);
  const [internshipData, setInternshipData] = useState([]);
  const [studentDisciplineName, setStudentDisciplineName] = useState("");
  const [flag, setflag] = useState(false);
  const [selectedInternship, setSelectedInternship] = useState(null);
  const [internshipStudentData, setInternshipStudentData] = useState({});
  const [getActiveEvents, setActiveEvents] = useState(null);
  const [eventMessage, setEventMessage] = useState("");
  const [isEventActive, setIsEventActive] = useState(false);
  const [isFirstSubmit, setFirstSubmit] = useState(false);
  const [isFirstSubmitExt, setFirstSubmitExt] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [savedInternship, setSavedInternship] = useState(null);
  const [isFormLocked, setIsFormLocked] = useState(false);
  const [internshipType, setInternshipType] = useState(null);
  const [selectedInternshipType, setSelectedInternshipType] = useState(null);
  const [showUpdateMode, setShowUpdateMode] = useState(false);
  const [courseCode, setCourseCode] = useState(null);
  const [courseName, setCourseName] = useState(null);
  const [externalInternship, setExternalInternship] = useState({
    title: "",
    provider: "",
    duration: "",
    mode: "",
    description: ""
  });


  // ✅ NEW STATE
  const [internshipSource, setInternshipSource] = useState("");
  const [isIPO, setIsIPO] = useState(false);
  const ipoProviders = ["Keltron", "ASAP"];

  const providerOptions = [
    { value: "Keltron course", label: "Keltron course" }
  ];

  let cid = localStorage.getItem("collegeid");
  let student_scheme_id = localStorage.getItem("scheme_id");

  const { http } = Api();
  const navigate = useNavigate();

  const formatDateTime = (dateTimeStr) => {
    if (!dateTimeStr) return "";

    const [datePart, timePart] = dateTimeStr.split(" ");
    const [year, month, day] = datePart.split("-");
    let [hours, minutes, seconds] = timePart.split(":");

    let period = "AM";
    hours = Number(hours);

    if (hours >= 12) {
      period = "PM";
      if (hours > 12) hours -= 12;
    }
    if (hours === 0) hours = 12;

    return `${day}-${month}-${year} ${hours
      .toString()
      .padStart(2, "0")}:${minutes}:${seconds} ${period}`;
  };

  // Check for course code
  useEffect(() => {
    if (internshipStudentData?.course_code) {
      setCourseCode(internshipStudentData.course_code);
      setCourseName(internshipStudentData.course_name);
    } else if (internshipStudentData?.course_code === null && Object.keys(internshipStudentData).length > 0) {
      toast.warning("You haven't taken any internship course in your current semester", {
        className: "toast-warning",
        autoClose: 5000
      });
    }
  }, [internshipStudentData]);

  useEffect(() => {
    const fetchInternshipData = async () => {
      http.get('/College/listTopicstudent')
        .then((response) => {
          if (response.data.status_code === 'ERR5') {
            setflag(true);
          }

          if (Array.isArray(response.data?.data)) {
            setInternshipData(response.data.data);
            setStudentDisciplineName(response.data.student.discipline_name);
            setInternshipStudentData(response.data.student);
          } else {
            setInternshipData([]);
            setStudentDisciplineName("null");
          }
        }).catch((error) => {
          setInternshipData([]);
          setStudentDisciplineName("null");

          const err = error.response?.data;
          if (err?.http_status === 401 && err?.status_code === 'ERR9') {
            toast.error("Invalid Token");
            setTimeout(() => navigate("/"), 5000);
          } else if (err?.http_status === 429 && err?.status_code === 'ERR33') {
            toast.error(err.message);
          } else {
            toast.error("Something went wrong");
          }
        });
    };

    fetchInternshipData();
  }, [reload]);

  useEffect(() => {
    if (!getActiveEvents) return;

    http.get("/College/getsavedInternshipTopic")
      .then((response) => {
        if (response.data?.status_code !== "MSG3") return;

        const saved = response.data.data;
        if (!saved || saved.length === 0) {
          toast.info("No saved internship application found for the current semester.");
          return;
        }
        console.log("saved", saved)
        setSavedInternship(saved);
        setInternshipType(saved.type);
        setSelectedInternshipType(saved.internship_type);

        // Check if update is allowed (event is active)
        const canUpdate = isEventActive;

        // Lock statuses
        const lockedStatuses = ["principal_approved", "iso_forwarded", "ino_forwarded"];
        setIsFormLocked(lockedStatuses.includes(saved.entry_status));

        // Initially show in view mode
        setShowUpdateMode(false);

        // Populate data based on type
        if (saved.type === "internal") {
          setIsNotListed(false);
          setInternshipSource("COLLEGE"); // ✅
          setSelectedCourse(saved.topic_id);
          setSelectedInternship({
            id: saved.topic_id,
            internship_topic: saved.internship_topic,
            mode_of_study: saved.mode_of_study,
            offered_by_name: saved.vendor_name,
            vendor_mobileno: saved.vendor_mobileno,
            vendor_email: saved.vendor_email,
            vendor_address: saved.vendor_address,
            description: saved.description
          });
        }

        if (saved.type === "external") {
          setIsNotListed(true);
          setSelectedCourse("EXTERNAL_LOCKED");







          if (ipoProviders.includes(saved.external_ipo_name)) {
            setIsIPO(true);
            setInternshipSource("IPO");
          } else {
            setIsIPO(false);
            setInternshipSource("NOT_LISTED");
          }

          setExternalInternship({
            title: saved.external_topic_name || "",
            provider: saved.external_ipo_name || "",
            duration: saved.external_ipo_duration || "",
            mode: saved.mode_of_study || "",
            description: saved.external_ipo_description || ""
          });
        }
      })
      .catch((error) => {
        console.log("error", error)

        const status = error.response?.status;
        const errorCode = error.response?.data?.status_code;
        const message = error.response?.data?.message || "Something went wrong";

        if (message.includes('Attempt to read property "user_id"') ||
          (status === 500 && message.includes("user_id"))) {
          toast.error("Session expired. Please log in again.");
          setTimeout(() => navigate("/"), 3000);
        } else if (status === 403 && errorCode === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/"), 3000);
        } else {
          toast.error(message);
        }
      });
    // }, [getActiveEvents, reload, isEventActive]);
  }, [getActiveEvents, reload]);

  useEffect(() => {
    const fetchActiveEvents = async () => {
      try {
        const response = await http.get('getActiveEvents', {
          params: { event_id: 33 }
        });

        const events = Array.isArray(response.data) ? response.data : [response.data];
        const matchedEvent = events.find(event =>
          Number(event.admission_year) === Number(internshipStudentData.admissionyear) &&
          Number(event.semester_id) === Number(internshipStudentData.currentsemester) &&
          event.status === "active" &&
          event.scheme_id === Number(student_scheme_id)
        );

        if (matchedEvent) {
          setActiveEvents(matchedEvent);
          setIsEventActive(true);
          setEventMessage(
            `Internship application window is open. Please submit your application on or before ${formatDateTime(matchedEvent.end_date)}.`
          );
        } else {
          setActiveEvents(null);
          setIsEventActive(false);
          setEventMessage("The internship application date is currently closed.");
        }
      } catch (error) {
        setActiveEvents(null);
        setIsEventActive(false);
        setEventMessage("");

        const message = error.response?.data?.message || "An error occurred";
        const status = error.response?.status;
        const errorCode = error.response?.data?.status_code;

        if (message.includes('Attempt to read property "user_id"') ||
          (status === 500 && message.includes('user_id'))) {
          toast.error("Session expired. Please log in again.");
          setTimeout(() => navigate("/"), 3000);
        } else if (status === 403 && errorCode === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/"), 3000);
        } else {
          toast.error(message);
        }
      }
    };

    if (internshipStudentData.admissionyear && internshipStudentData.currentsemester) {
      fetchActiveEvents();
    }
  }, [internshipStudentData.admissionyear, internshipStudentData.currentsemester]);

  const handleUpdateClickq = () => {
    setShowUpdateMode(true);
    //setIsFormLocked(false); // Enable editing in update mode
    setInternshipSource(savedInternship.internship_type);
  };
  const handleUpdateClick = () => {
    setShowUpdateMode(true);

    const type = savedInternship.internship_type;
    setInternshipSource(type);

    if (type === "COLLEGE") {
      setIsIPO(false);
      setIsNotListed(false);
    }

    if (type === "IPO") {
      setIsIPO(true);
      setIsNotListed(true);
    }

    if (type === "NOT_LISTED") {
      setIsIPO(false);
      setIsNotListed(true);
    }
  };
  const handleFinalSubmit = () => {
    //if (!validateExternalForm()) return;

    if (!selectedInternship) return;

    setLoading(true);

    http.post("/College/saveInternshipTopic", {
      topic_id: selectedInternship.id,
      mode_of_study: selectedInternship.mode_of_study,
      type: 'internal',
      internship_type: internshipSource
    })
      .then((response) => {
        if (response.data.status_code === "MSG3" || response.status === 200) {
          toast.success("Internship updated successfully!");
          setFirstSubmit(false);
          setShowUpdateMode(false);
          setReload(!reload);
        }
      })
      .catch((error) => {
        const status = error.response?.data?.http_status;
        if (status === 403) {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/"), 3000);
        } else {
          toast.error("Failed to update internship");
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  console.log("internshipSource", internshipSource)
  const handleCancel = () => {
    setFirstSubmit(false);
  };
  const cancelForm = () => {
    window.location.reload();
  };

  const handleExternalChange = (e) => {
    const { name, value } = e.target;
    setExternalInternship((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const validateExternalForm = () => {
    if (!externalInternship.title?.trim()) {
      toast.error("Please enter Internship Title");
      return false;
    }
    if (!externalInternship.provider?.trim()) {
      toast.error("Please enter Internship Provider");
      return false;
    }
    // if (!externalInternship.duration) {
    //   toast.error("Please select Internship Duration");
    //   return false;
    // }
    if (!externalInternship.mode) {
      toast.error("Please select Mode of Internship");
      return false;
    }
    return true; // all validations passed
  };
  const setFirstSubmitData = () => {
    if (!validateExternalForm()) return;
    setFirstSubmitExt(true);
  };

  const handleFinalSubmitExt = () => {
    setLoading(true);

    const payload = {
      topic_id: null,
      type: 'external',
      internship_type: internshipSource,
      external_topic_name: externalInternship.title,
      external_ipo_name: externalInternship.provider,
      external_ipo_duration: externalInternship.duration,
      mode_of_study: externalInternship.mode,
      external_ipo_description: externalInternship.description
    };

    http.post("/College/saveInternshipTopic", payload)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Internship updated successfully");
          setFirstSubmitExt(false);
          setShowUpdateMode(false);
          setReload(!reload);
        }
      })
      .catch(() => {
        toast.error("Failed to update internship");
      })
      .finally(() => setLoading(false));
  };

  const handleCancelExt = () => {
    setFirstSubmitExt(false);
  };

  const CreateTableStyle = {

    control: (base, state) => ({
      ...base,
      minHeight: "42px",
      borderRadius: "10px",
      borderColor: state.isFocused
        ? "#2563eb"
        : "#e5e7eb",
      boxShadow: state.isFocused
        ? "0 0 0 1px #2563eb"
        : "none",
      outline: "none",
      fontSize: "14px",
      fontFamily: "inherit",
      "&:hover": {
        borderColor: "#2563eb"
      }
    }),

    valueContainer: (base) => ({
      ...base,
      padding: "0 12px"
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "42px"
    }),
    placeholder: (base) => ({
      ...base,
      color: "#9ca3af"
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "10px"
    })
  };


  useEffect(() => {
    if (savedInternship) {
      setInternshipSource(savedInternship.internship_type);
    }
  }, [savedInternship]);
  // Render saved internship view
  const renderSavedInternship = () => {
    if (!savedInternship) return null;

    const getStatusClass = (status) => {
      const statusMap = {
        'entered': 'entered',
        'principal_reverted': 'principal_reverted',
        'iso_reverted': 'iso_reverted',
        'principal_approved': 'principal_approved',
        'iso_forwarded': 'iso_forwarded'
      };
      return statusMap[status] || '';
    };

    return (
      <div className={`card details-card saved-card ${!showUpdateMode ? '' : 'edit-mode'}`}>
        <div className="badge-group" style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
          <span className={`status-badge ${savedInternship.type}`}>
            {savedInternship.type === 'internal' ? '🏢 Internal' : '🌐 External'}
          </span>
          <span className={`status-badge ${getStatusClass(savedInternship.entry_status)}`}>
            Status: {savedInternship.entry_status?.replace('_', ' ')}
          </span>
          {/* {courseCode && (
            <span className="course-code-badge">
              Course Code: {courseCode}-{courseName}
            </span>
          )} */}
        </div>

        {!showUpdateMode ? (
          // VIEW MODE - Show details without form controls
          <>
            {/* {(internshipSource || savedInternship.internship_type) === "COLLEGE" ? ( */}
            {savedInternship.type === 'internal' ? (
              <>
                <h3 className="m-10">
                  {savedInternship.internship_topic}
                  {courseCode && <span className="course-code-badge">Course Code: {courseCode}-{courseName}</span>}
                </h3>

                <div className="row info-grid-bs">
                  <div className="col-12 col-md-6 mb-3">
                    <div className="info-item">
                      <label>Offered By</label>
                      <span>{savedInternship.vendor_name}</span>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <div className="info-item">
                      <label>Mode of Study</label>
                      <span>{savedInternship.mode_of_study}</span>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <div className="info-item">
                      <label>Vendor Mobile</label>
                      <span>{savedInternship.vendor_mobileno}</span>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <div className="info-item">
                      <label>Vendor Email</label>
                      <span>{savedInternship.vendor_email}</span>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="info-item">
                      <label>Vendor Address</label>
                      <span style={{ whiteSpace: "pre-line" }}>
                        {savedInternship.vendor_address}
                      </span>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              // External view mode
              <>
                <h3>
                  Internship Details
                  {courseCode && <span className="course-code-badge">Course: {courseCode}-{courseName}</span>}
                </h3>

                <div className="row info-grid-bs">
                  <div className="col-12 col-md-6 mb-3">
                    <div className="info-item">
                      <label>Internship Title</label>
                      <span>{savedInternship.external_topic_name}</span>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <div className="info-item">
                      <label>Provider</label>
                      <span>{savedInternship.external_ipo_name}</span>
                    </div>
                  </div>
                  {/* Duration hide */}
                  {/* <div className="col-12 col-md-6 mb-3">
                    <div className="info-item">
                      <label>Duration</label>
                      <span>{savedInternship.external_ipo_duration} Months</span>
                    </div>
                  </div> */}

                  <div className="col-12 col-md-6 mb-3">
                    <div className="info-item">
                      <label>Mode</label>
                      <span>{savedInternship.mode_of_study}</span>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="info-item">
                      <label>Description</label>
                      <span>{savedInternship.external_ipo_description || 'N/A'}</span>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* Update button - only show if event is active */}
            {isEventActive && !isFormLocked && (
              <div className="actions actions-right">
                <button
                  className="btn-update"
                  onClick={handleUpdateClick}
                >
                  Update Internship
                </button>
              </div>
            )}

            {/* Note about update availability */}
            {isEventActive && !isFormLocked && (
              <div className="update-note">
                You can update your internship application until {formatDateTime(getActiveEvents?.end_date)}
              </div>
            )}

            {isFormLocked && (
              <p className="text-center text-danger mt-3">
                This internship submission has already been forwarded/approved and cannot be edited.
              </p>
            )}

            {!isEventActive && !isFormLocked && (
              <p className="text-center text-warning mt-3">
                The application window is closed. No further updates are allowed.
              </p>
            )}
          </>
        ) : (
          // UPDATE MODE - Show editable form
          <>
            {/* {savedInternship.type === 'internal' ? ( */}
            {(internshipSource || savedInternship.internship_type) === "COLLEGE" ? (   // ✔ ADDED
              <>
                <h3>Update Internship Details: {savedInternship.internship_topic}</h3>
                <p>Select Internship Providing Organisation(IPO)<span className="errorclr">*</span></p>

                {/* ✅ FIRST SELECT BOX */}
                <select
                  //value={internshipSource}
                  value={internshipSource || savedInternship.internship_type}
                  //disabled={savedInternship.internship_type === "COLLEGE"}
                  onChange={(e) => {
                    const value = e.target.value;
                    setInternshipSource(value);

                    if (value === "COLLEGE") {
                      setIsNotListed(false);
                      setIsIPO(false);
                    }

                    if (value === "IPO") {
                      setIsIPO(true);
                      setIsNotListed(true);
                    }

                    if (value === "NOT_LISTED") {
                      setIsIPO(false);
                      setIsNotListed(true);
                    }
                  }}
                // style={{ marginBottom: "20px" }}
                >
                  <option value="">--- Select ---</option>
                  <option value="COLLEGE">College Enlisted</option>
                  <option value="IPO">University Enlisted</option>
                  {/* <option value="IPO">IPO (Keltron / ASAP)</option> */}
                  <option value="NOT_LISTED">Others</option>
                </select>


                <p>Select Internship Topic<span className="errorclr">*</span></p>
                {/* {(internshipSource || savedInternship.internship_type) === "COLLEGE" && (   // ✔ NEW */}
                {internshipSource === "COLLEGE" && (

                  <>
                    <select
                      value={selectedCourse}
                      onChange={(e) => {
                        const value = e.target.value;
                        setSelectedCourse(value);

                        const internship = internshipData.find(
                          (item) => item.id === Number(value)
                        );

                        setSelectedInternship(internship || null);
                      }}
                    // style={{ marginBottom: "20px" }}
                    >
                      <option value="">-- Select Course --</option>
                      {internshipData.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.internship_topic}
                        </option>
                      ))}
                    </select>

                    {selectedInternship && (
                      <div className="row info-grid-bs">
                        <div className="col-12 col-md-6 mb-3">
                          <div className="info-item">
                            <label>Offered By</label>
                            <span>{selectedInternship.offered_by_name}</span>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 mb-3">
                          <div className="info-item">
                            <label>Mode of Study</label>
                            <select
                              value={selectedInternship.mode_of_study}
                              onChange={(e) =>
                                setSelectedInternship({
                                  ...selectedInternship,
                                  mode_of_study: e.target.value
                                })
                              }
                            >
                              <option value="online">Online</option>
                              <option value="offline">Offline</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 mb-3">
                          <div className="info-item">
                            <label>Vendor Mobile</label>
                            <span>{selectedInternship.vendor_mobileno}</span>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 mb-3">
                          <div className="info-item">
                            <label>Vendor Email</label>
                            <span>{selectedInternship.vendor_email}</span>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="info-item">
                            <label>Vendor Address</label>
                            <span>{selectedInternship.vendor_address}</span>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}

                <div className="actions actions-right">
                  <button
                    className="btn-secondary"
                    onClick={() => {
                      setShowUpdateMode(false);
                      setReload(!reload);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn-primary"
                    onClick={() => setFirstSubmit(true)}
                    disabled={loading}
                  >
                    {loading ? "Updating..." : "Update"}
                  </button>
                </div>
              </>
            ) : (
              // External update mode
              <>
                <h3>Update Internship Details</h3>

                {/* ✅ EXTERNAL / IPO FORM */}

                {/* FIRST SELECT BOX */}
                <p>Select Internship Providing Organisation(IPO)<span className="errorclr">*</span></p>
                <select
                  value={internshipSource || savedInternship.internship_type}
                  onChange={(e) => {
                    const value = e.target.value;
                    setInternshipSource(value);
                    // ✅ RESET EXTERNAL FORM
                    setExternalInternship({
                      title: "",
                      provider: "",
                      duration: "",
                      description: "",
                      mode: ""
                    }); setSelectedCourse("");
                    setSelectedInternship(null);
                    if (value === "COLLEGE") {
                      setIsIPO(false);
                      setIsNotListed(false);
                    }

                    if (value === "IPO") {
                      setIsIPO(true);
                      setIsNotListed(true);
                    }

                    if (value === "NOT_LISTED") {
                      setIsIPO(false);
                      setIsNotListed(true);
                    }
                  }}
                  style={{ marginBottom: "20px" }}
                >
                  <option value="">--- Select ---</option>
                  <option value="COLLEGE">College Enlisted</option>
                  <option value="IPO">University Enlisted</option>
                  {/* <option value="IPO">IPO (Keltron / ASAP)</option> */}
                  <option value="NOT_LISTED">Others</option>
                </select>

                {internshipSource === "COLLEGE" && (
                  <>
                    <select
                      value={selectedCourse}
                      onChange={(e) => {
                        const value = e.target.value;
                        setSelectedCourse(value);

                        const internship = internshipData.find(
                          (item) => item.id === Number(value)
                        );

                        setSelectedInternship(internship || null);
                      }}
                    // style={{ marginBottom: "20px" }}
                    >
                      <option value="">-- Select Course --</option>
                      {internshipData.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.internship_topic}
                        </option>
                      ))}
                    </select>
                  </>
                )}


                {/* {internshipSource !== "COLLEGE" && ( */}
                {(internshipSource || savedInternship.internship_type) !== "COLLEGE" && (   // ✔ NEW
                  <>
                    <div className="form-grid">

                      <div className="form-group">
                        <label>Internship Title<span className="errorclr">*</span></label>
                        <input
                          type="text"
                          name="title"
                          value={externalInternship.title}
                          onChange={handleExternalChange}
                        />
                      </div>

                      <div className="form-group">
                        <label>Internship Provider<span className="errorclr">*</span></label>

                        {/* ✅ IPO SELECT */}
                        {isIPO && (
                          <select
                            name="provider"
                            value={externalInternship.provider}
                            onChange={handleExternalChange}
                          >
                            <option value="">-- Select Provider --</option>
                            <option value="Keltron">Keltron</option>
                            <option value="ASAP">ASAP</option>
                          </select>
                        )}

                        {/* ✅ NOT LISTED INPUT */}
                        {!isIPO && (
                          <input
                            type="text"
                            name="provider"
                            value={externalInternship.provider}
                            onChange={handleExternalChange}
                          />
                        )}
                      </div>
                      {/* Duration hide */}
                      {/* <div className="form-group">
        <label>Duration (Months)<span className="errorclr">*</span></label>
        <select
          name="duration"
          value={externalInternship.duration}
          onChange={handleExternalChange}
        >
          <option value="">-- Select Duration --</option>
          {[1,2,3,4,5,6].map(m => (
            <option key={m} value={m}>{m} Month</option>
          ))}
        </select>
      </div> */}

                      <div className="form-group">
                        <label>Mode of Internship<span className="errorclr">*</span></label>
                        <select
                          name="mode"
                          value={externalInternship.mode}
                          onChange={handleExternalChange}
                        >
                          <option value="">-- Select Mode --</option>
                          <option value="online">Online</option>
                          <option value="offline">Offline</option>
                        </select>
                      </div>

                    </div>

                    <div className="form-group">
                      <label>Description</label>
                      <textarea
                        name="description"
                        value={externalInternship.description}
                        onChange={handleExternalChange}
                        rows={4}
                      />
                    </div>
                  </>
                )}



                <div className="actions actions-right">
                  <button
                    className="btn-secondary"
                    onClick={() => {
                      setShowUpdateMode(false);
                      setReload(!reload);
                    }}
                  >
                    Cancel
                  </button>

                  {internshipSource === "COLLEGE" ? (
                    <button
                      className="btn-primary"
                      onClick={() => setFirstSubmit(true)}
                      disabled={loading}
                    >
                      {loading ? "Updating..." : "Update"}
                    </button>
                  ) : (
                    <button
                      className="btn-primary"
                      onClick={() => setFirstSubmitData(true)}
                      disabled={loading}
                    >
                      {loading ? "Updating..." : "Update"}
                    </button>
                  )}
                </div>
              </>
            )}
          </>
        )}
      </div>
    );
  };

  return (
    <StudentTemplate>
      <ToastContainer />

      <div className="internship-section">
        <div className="internship-wrapper">
          {/* SELECT COURSE - Only show if no saved internship or in update mode for new selection */}
          {!savedInternship && (
            <div className="card select-card">
              <h4>Select Internship Providing Organisation(IPO)</h4>

              {/* ✅ NEW FIRST SELECT */}
              <select
                value={internshipSource}
                onChange={(e) => {
                  const value = e.target.value;
                  setInternshipSource(value);

                  if (value === "COLLEGE") {
                    setIsNotListed(false);
                    setIsIPO(false);
                  }

                  if (value === "IPO") {
                    setIsIPO(true);      // ✅
                    setIsNotListed(true);
                    setSelectedInternship(null);
                  }

                  if (value === "NOT_LISTED") {
                    setIsNotListed(true);
                    setIsIPO(false);     // ✅
                    setSelectedInternship(null);
                  }
                }}
              >
                <option value="">--- Select ---</option>
                <option value="COLLEGE">College Enlisted</option> {/* ✅ */}
                {/* <option value="IPO">IPO (Internship Provider Organisation)</option> */}
                <option value="IPO">University Enlisted</option> {/* ✅ */}
                <option value="NOT_LISTED">Others</option> {/* ✅ */}
              </select>

              <div className="m-t-10">
                {/* ✅ SHOW ONLY FOR COLLEGE */}
                {internshipSource === "COLLEGE" && (
                  <>
                    <h4>Select Internship Topic</h4>

                    <select
                      value={selectedCourse}
                      disabled={isFormLocked}
                      onChange={(e) => {
                        const value = e.target.value;
                        setSelectedCourse(value);

                        const internship = internshipData.find(
                          (item) => item.id === Number(value)
                        );

                        setSelectedInternship(internship || null);
                      }}
                    >
                      <option value="">-- Select Course --</option>

                      {courseCode && internshipData.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.internship_topic}
                        </option>
                      ))}

                    </select>
                  </>
                )}
              </div>

              {/* MESSAGE SHOWN ON PAGE LOAD */}
              {eventMessage && (
                <p className={`event-msg ${isEventActive ? "active" : "closed"}`}>
                  {eventMessage}
                </p>
              )}
            </div>
          )}

          {/* Show saved internship if exists */}
          {savedInternship && renderSavedInternship()}

          {/* Show new selection forms only if no saved internship */}
          {!savedInternship && selectedInternship && !isNotListed && getActiveEvents && (
            <div className="card details-card">
              <span className="badge">Discipline: {studentDisciplineName}</span>
              {courseCode && (
                <span className="course-code-badge">
                  Course Code: {courseCode}-{courseName}
                </span>
              )}

              <h3>{selectedInternship.internship_topic}</h3>

              <div className="row info-grid-bs">
                <div className="col-12 col-md-6 mb-3">
                  <div className="info-item">
                    <label>Offered By</label>
                    <span>{selectedInternship.offered_by_name}</span>
                  </div>
                </div>

                <div className="col-12 col-md-6 mb-3">
                  <div className="info-item">
                    <label>Mode of Study</label>
                    <span>{selectedInternship.mode_of_study}</span>
                  </div>
                </div>

                <div className="col-12 col-md-6 mb-3">
                  <div className="info-item">
                    <label>Vendor Mobile</label>
                    <span>{selectedInternship.vendor_mobileno}</span>
                  </div>
                </div>

                <div className="col-12 col-md-6 mb-3">
                  <div className="info-item">
                    <label>Vendor Email</label>
                    <span className="break-word">
                      {selectedInternship.vendor_email}
                    </span>
                  </div>
                </div>

                <div className="col-12">
                  <div className="info-item">
                    <label>Vendor Address</label>
                    <span>{selectedInternship.vendor_address}</span>
                  </div>
                </div>
              </div>

              <div className="actions actions-right">
                <button className="btn-secondary"
                  onClick={() => cancelForm()}
                >Cancel</button>
                <button
                  className="btn-primary"
                  onClick={() => setFirstSubmit(true)}
                >
                  Save
                </button>
              </div>
            </div>
          )}

          {/* NOT LISTED FORM - Only show if no saved internship */}
          {/* ✅ IPO OR NOT LISTED */}
          {!savedInternship && (isNotListed || isIPO) && getActiveEvents && (
            <div className="card details-card">
              <h3>Internship Details</h3>
              {courseCode && (
                <span className="course-code-badge" style={{ marginBottom: '15px', display: 'inline-block' }}>
                  Course Code: {courseCode}-{courseName}
                </span>
              )}

              <div className="form-grid">
                <div className="form-group">
                  <label>Internship Title <span className="errorclr">*</span></label>
                  <input
                    type="text"
                    name="title"
                    value={externalInternship.title}
                    onChange={handleExternalChange}
                  />
                </div>

                {/* <div className="form-group">
                  <label>Internship Provider Q<span className="errorclr">*</span></label>
                  <input
                    type="text"
                    name="provider"
                    value={externalInternship.provider}
                    onChange={handleExternalChange}
                  />
                </div> */}
                <div className="form-group">
                  <label>
                    Internship Provider<span className="errorclr">*</span>
                  </label>

                  {/* ✅ IPO SELECT */}
                  {isIPO && (
                    <select
                      name="provider"
                      value={externalInternship.provider}
                      onChange={handleExternalChange}
                    >
                      <option value="">-- Select Provider --</option>
                      <option value="Keltron">Keltron</option>
                      <option value="ASAP">ASAP</option>
                    </select>
                  )}

                  {/* ✅ TEXT INPUT FOR NOT LISTED */}
                  {!isIPO && (
                    <input
                      type="text"
                      name="provider"
                      value={externalInternship.provider}
                      onChange={handleExternalChange}
                      placeholder="Enter Internship Provider"
                    />
                  )}
                </div>
                {/* //Duration hide */}
                {/* <div className="form-group">
                  <label>Duration (Months)<span className="errorclr">*</span></label>
                  <select
                    name="duration"
                    value={externalInternship.duration}
                    onChange={handleExternalChange}
                  >
                    <option value="">-- Select Duration --</option>
                    {[1, 2, 3, 4, 5, 6].map(m => (
                      <option key={m} value={m}>{m} Month</option>
                    ))}
                  </select>
                </div> */}

                <div className="form-group">
                  <label>Mode of Internship <span className="errorclr">*</span></label>
                  <select
                    name="mode"
                    value={externalInternship.mode}
                    onChange={handleExternalChange}
                  >
                    <option value="">-- Select Mode --</option>
                    <option value="online">Online</option>
                    <option value="offline">Offline</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label>Description</label>
                <textarea
                  name="description"
                  value={externalInternship.description}
                  onChange={handleExternalChange}
                  rows={4}
                />
              </div>

              <div className="actions actions-right">
                <button className="btn-secondary"
                  onClick={() => cancelForm()}>
                  Cancel</button>
                <button
                  className="btn-primary"
                  onClick={() => setFirstSubmitData(true)}
                >
                  Save
                </button>
              </div>
            </div>
          )}

          {/* Confirmation Modals */}
          {isFirstSubmit && (
            <div
              className="modal fade show d-block"
              tabIndex="-1"
              role="dialog"
              aria-modal="true"
              style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">
                    <div className="modal-toggle-wrapper">
                      <h4 className="text-center pb-2">
                        Confirm Internship {savedInternship ? 'Update' : 'Submission'}
                      </h4>

                      <p className="txt-aln-jst">
                        You are about to {savedInternship ? 'update your' : 'submit your'} internship application for
                        <strong> {selectedInternship?.internship_topic}</strong>.
                        {courseCode && <><br />Course Code: <strong>{courseCode}-{courseName}</strong></>}
                        <br />Please confirm to proceed.
                      </p>

                      <div className="d-flex justify-content-center mt-4">
                        <button
                          className="btn"
                          style={{
                            backgroundColor: "white",
                            borderColor: "red",
                            color: "black"
                          }}
                          onClick={handleCancel}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn btn-danger mx-2"
                          onClick={handleFinalSubmit}
                          disabled={loading}
                        >
                          {loading ? "Saving..." : "Save"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {isFirstSubmitExt && (
            <div
              className="modal fade show d-block"
              tabIndex="-1"
              role="dialog"
              aria-modal="true"
              style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">
                    <div className="modal-toggle-wrapper">
                      <h4 className="text-center pb-2">
                        Confirm Internship {savedInternship ? 'Update' : 'Submission'}
                      </h4>

                      <p className="txt-aln-jst">
                        You are about to {savedInternship ? 'update the' : 'submit the'} external internship&nbsp;
                        <strong> {externalInternship.title}</strong>.
                        {courseCode && <><br />Course Code: <strong>{courseCode}-{courseName}</strong></>}
                        <br />Please confirm to proceed.
                      </p>

                      <div className="d-flex justify-content-center mt-4">
                        <button
                          className="btn"
                          style={{
                            backgroundColor: "white",
                            borderColor: "red",
                            color: "black"
                          }}
                          onClick={handleCancelExt}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn btn-danger mx-2"
                          onClick={handleFinalSubmitExt}
                          disabled={loading}
                        >
                          {loading ? "Saving..." : "Save"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </StudentTemplate>
  );
};

export default StudentInternship;
